<template>
  <v-stepper v-model="newValue" non-linear class="no-box-shadow" bg-color="white">
    <v-stepper-header>
      <template
        v-for="(step, index) in steps"
      >
        <v-stepper-step
          editable
          :step="step.index"
          :color="stepColor"
          :class="[{'disabled': !step.visitedStep}, 'rounded-lg']"
        >
          {{ step.name }}
        </v-stepper-step>

        <v-divider v-if="steps.length !== index + 1" />
      </template>
    </v-stepper-header>
  </v-stepper>
</template>

<script>
import { ref, watch } from '@vue/composition-api';

export default {
  props: {
    value: {
      type: Number,
      default: 1
    },
    steps: {
      type: Array,
      default: null
    },
    stepColor: {
      type: String,
      default: ''
    }
  },
  setup (props, context) {
    const newValue = ref(props.value);

    watch(newValue, () => {
      context.emit('input', newValue.value);
    });

    watch(() => props.value, () => {
      newValue.value = props.value;
    });

    return { newValue };
  }
};
</script>
